// extracted by mini-css-extract-plugin
export default {"wrapper":"CreateRow_wrapper__D5C6P","title":"CreateRow_title__serYN","btn":"CreateRow_btn__iSiF8"};